import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from '@mui/material';

const RenameQueryDialog = ({ open, onClose, onRename, query }) => {
  const [queryName, setQueryName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && query) {
      setQueryName(query.name);
      setError('');
    }
  }, [open, query]);

  const handleRename = () => {
    if (!queryName.trim()) {
      setError('Query name is required');
      return;
    }

    if (queryName.length > 100) {
      setError('Query name must be 100 characters or less');
      return;
    }

    onRename(query.id, queryName.trim());
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Rename Query</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label='Query Name'
          value={queryName}
          onChange={(e) => setQueryName(e.target.value)}
          error={!!error}
          helperText={error}
          inputProps={{ maxLength: 100 }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleRename} variant='contained' color='primary'>
          Rename
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RenameQueryDialog;
